import { ViewContainer } from '@fortem-monorepo/react-spa'

import { Page } from '@/components/Page'
import { TRADING } from '@/constants/links'
import { BookTradeFormV2 } from '@/pages/trading/new-trade/components/BookTradeFormV2'

export interface BookTradePageProps {}

export const BookTradePage: React.FC<BookTradePageProps> = ({}) => {
  return (
    <Page metadata={{ title: 'New Trade' }} permissions={TRADING.BOOK.permissions}>
      <ViewContainer>
        <BookTradeFormV2 />
      </ViewContainer>
    </Page>
  )
}
